import React, { useState, useEffect } from "react";
import {
  Page,
  Icon,
  Link,
  f7,
  Block,
  List,
  ListItem,
  AccordionContent,
} from "framework7-react";
import Accordion from "react-bootstrap/Accordion";
import axios from "axios";
import { API_BASE_URL, API_AUTH } from "./../globals";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";

const stripePromise = loadStripe(
  "pk_live_51NkzJkK8iuTQxG2ZSOxU469AzA5Rx8uJsMT4PVSLsuZUCZaSfhoZ3tCW0RMZFMJxJ7f2FIGZnElQYr5ufYW1BI8P00gW5cYvKs"
);

const PaymentPage = ({ f7route }) => {
  const { id } = f7route.params;
  const [data, setPaymentDetails] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [couponDetails, setCouponDetails] = useState("");
  const [paymentData, setPaymentData] = useState([]);
  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };
  useEffect(() => {
    axios
      .get(API_BASE_URL + "paycustdetail", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          id: id,
        },
      })
      .then((response) => {
        setPaymentDetails(response.data);
      })
      .catch((error) => console.log(error));
  }, [id]);
  console.log(data);
  const amountToPay = data.map((item) => item.grand_total - couponDetails)[0];
  useEffect(() => {
    const couponDetails =
      JSON.parse(localStorage.getItem("couponDiscount")) || "";
    setCouponDetails(couponDetails);
    setPaymentData({
      order_id: id,
      cust_id: localStorage.getItem("id"),
      rest_id: data.map((item) => item.rest_id)[0],
      event_id: data.map((item) => item.event_id)[0],
      payment_type: "1",
      payment_status: "1",
      coupon_discount: couponDetails,
      amount: amountToPay,
    });
  }, [data]);

  const savePayment = () => {
    axios
      .post(API_BASE_URL + "payment", paymentData, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        f7.toast
          .create({
            text: "Successfully paid..!",
            position: "top",
            cssClass: "bg-color-teal",
            closeTimeout: 3000,
          })
          .open();
        f7.views.main.router.navigate({ name: "bidtab" });
      })
      .catch((error) =>
        f7.toast
          .create({
            text: "Check the card number..!",
            position: "top",
            cssClass: "bg-color-red",
            closeTimeout: 3000,
          })
          .open()
      );
  };

  const blockStyle = {
    display: "block",
    visibility: "visible",
    // You can add more CSS properties here
    // For example: backgroundColor: 'blue', fontSize: '16px', etc.
  };

  return (
    <Page className="bg-white">
      <div className="container container-table ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="custom-container container-lg p-0">
              <div className="header-panel">
                <Link href="#" back>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>
                </Link>
                <h2>Payment</h2>
                {/* <Link href="#"><Icon ios="material:edit" aurora="material:edit" md="material:edit" className='theme-dark'></Icon></Link> */}
              </div>
            </div>
          </header>
          {data.map((item) => (
            <section className="mt-0">
              {/* <section>
              <div class="custom-container p-0">
                 <h3 class="fw-semibold dark-text">Food Categories</h3>
                {console.log(item.order_item)}
                {item.order_item.map((items, index)=>(
                <div class="horizontal-product-box mt-3">
                  <div class="product-img">
                    <img class="img-fluid img" src={`${IMG_URL}${items.menu_item_picture}`} alt={items.menu_item_name}/>
                  </div>
                  <div class="product-content">
                    <h5>{items.item_name}</h5>
                    <h6> Qty : {items.quantity}, Price : {items.price}</h6>
                    <div class="plus-minus">
                      <i class="ri-subtract-line sub"></i>
                      <input type="number" value="1" min="1" max="10"/>
                      <i class="ri-add-line add"></i>
                    </div>
                    <img class="red-symbol" src={require("./../images/svg/nonveg.svg").default} alt="non-veg"/>
                    <h3 class="product-price">${items.total_amount}</h3>
                  </div>
                </div>
                ))}
              </div>
            </section> */}
              <section class="profile-form bill-details">
                <div class="p-0 mt-0">
                  <h3 class="fw-semibold dark-text text-center text-5 p-1 mt-0">
                    Billing Amount
                  </h3>
                  <h1 class="fw-semibold amount text-center text-10 text-success p-5">
                    ${parseFloat(item.grand_total - couponDetails).toFixed(2)}
                  </h1>
                </div>
              </section>
              <section className="bill-details mb-0">
                <div className="custom-container p-0">
                  <h3 className="fw-bold dark-text">Payment Details </h3>
                  <table className="table table-sm mt-2 text-2">
                    <tbody>
                      <tr>
                        <td>Sub Total</td>
                        <td className="text-end">
                          $ {parseFloat(item.sub_total).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Discount{" "}
                          <span className="text-success fw-bold text-2">
                            {item.discount > 0 && item.promo > 0
                              ? `(${item.discount_note})`
                              : ""}
                          </span>
                        </td>
                        <td className="text-end">
                          $ {parseFloat(item.discount).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td>Coupon Discount</td>
                        <td className="text-end">
                          ${" "}
                          {couponDetails !== ""
                            ? parseFloat(couponDetails).toFixed(2)
                            : 0.0}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Sales Tax{" "}
                          <span className="text-success fw-bold text-2">
                            {item.tax > 0 ? `(${item.sales_tax}%)` : ""}
                          </span>
                        </td>
                        <td className="text-end">
                          $ {parseFloat(item.tax).toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td>Sub Total</td>
                        <td className="text-end fw-bold">
                          ${" "}
                          {parseFloat(item.grand_total - couponDetails).toFixed(
                            2
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
              <section class="delivery address ">
                {item.delivery_type !== "Pick up" ? (
                  <div class="custom-container p-0">
                    <h3 class="fw-semibold dark-text">Event Address</h3>
                    <div class="cart-add-box mt-3 mb-3">
                      {/* <div class="add-img">
                    <img class="img-fluid img" src={require("./../images/home.png").default} alt="rp1"/>
                  </div> */}
                      <div class="add-content">
                        {/* <h5 class="fw-semibold dark-text">Deliver to : {item.city}</h5> */}
                        <h6 class="address light-text mt-1">
                          {item.add_lin_1}. {item.city}, {item.zip_code}
                        </h6>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </section>
              <section class="delivery address ">
                <div class="custom-container p-0 mb-3">
                  <h3 class="fw-semibold dark-text mb-0">Select Payment</h3>
                </div>

                <Accordion defaultActiveKey="0" className="text-2">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <span className="text-2 text-dark">Card Payment</span>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Elements stripe={stripePromise}>
                        <CheckoutForm
                          amountToPay={amountToPay}
                          paymentData={paymentData}
                        />
                      </Elements>
                    </Accordion.Body>
                  </Accordion.Item>
                  {/* <Accordion.Item eventKey="1">
                  <Accordion.Header><span className='text-2 text-dark'>Cash on Delivery</span></Accordion.Header>
                  <Accordion.Body>
                    <div class="add-content">
                      <h5 class="fw-semibold dark-text">Deliver to : {item.city}</h5>
                      <h6 class="address light-text mt-1">{item.add_lin_1}. {item.city}, {item.zip_code}</h6>
                      <button className="btn theme-btn w-100 mt-3" onClick={savePayment}>
                        Confirm COD
                      </button>
                    </div>
                  </Accordion.Body>
                </Accordion.Item> */}
                </Accordion>
              </section>

              {/* <section class="payment method section-lg-b-space ">
              <div class="custom-container p-0">
                <h3 class="fw-semibold dark-text section-t-space">Payment Type</h3>
                <ul class="payment-list section-lg-b-space">
                  <li class="cart-add-box payment-card-box gap-0 mt-3">
                    <div class="payment-detail">
                      <div class="add-img">
                        <img class="img-fluid img" src={require("./../images/icons/svg/paypal.svg").default} alt="mastercard"/>
                      </div>
                      <div class="add-content">
                        <div>
                          <h5 class="fw-semibold">Pay Pal</h5>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" onChange={handleRadioChange} type="radio" name="flexRadioDefault"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="cart-add-box payment-card-box gap-0 mt-3">
                    <div class="payment-detail">
                      <div class="add-img">
                        <img class="img-fluid img img1" src={require("./../images/icons/svg/apple-pay.svg").default} alt="apple-pay"/>
                      </div>
                      <div class="add-content">
                        <div>
                          <h5 class="fw-semibold">Apple Pay</h5>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" onChange={handleRadioChange} type="radio" name="flexRadioDefault"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="cart-add-box payment-card-box gap-0 mt-3">
                    <div class="payment-detail">
                      <div class="add-img">
                        <img class="img-fluid img" src={require("./../images/icons/svg/google-pay.svg").default} alt="google-pay"/>
                      </div>
                      <div class="add-content">
                        <div>
                          <h5 class="fw-semibold">Google Pay</h5>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input"  onChange={handleRadioChange} type="radio" name="flexRadioDefault"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="cart-add-box payment-card-box gap-0 mt-3">
                    <div class="payment-detail">
                      <div class="add-img">
                        <img class="img-fluid img" src={require("./../images/icons/svg/cash.svg").default} alt="cash"/>
                      </div>
                      <div class="add-content">
                        <div>
                          <h5 class="fw-semibold">Cash on Delivery</h5>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" value="" onChange={handleRadioChange} type="radio" name="flexRadioDefault"/>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </section> */}
              {/* <section>
              <div className="pay-popup">
                <div className="price-items">
                  <h3>Total : ${item.grand_total}</h3>
                
                  <h6>2 item Added</h6>
                </div>
                <a type="button"  className="btn theme-btn pay-btn mt-0" onClick={savePayment}>Pay Now</a>
              </div>
            </section> */}
            </section>
          ))}
        </div>
      </div>
    </Page>
  );
};

export default PaymentPage;
